export default {
    app: {
        titleName: 'BigC Employee Profile'
    },
    txt: {
        no: 'No.',
        profile: 'โปรไฟล์',
        logout: 'ออกจากระบบ',
        hour:'ชั่วโมง',
        minute:'นาที',
        fullName:'ชื่อ-นามสกุล: {userName}',
        empNo:'รหัสพนักงาน: {empNo}',
        action:'การกระทำ',
        th:'TH',
        en:'EN',
        number:'ลำดับที่',
        langTh:'ภาษาไทย',
        langEn:'English',
        format:'Format',
        store:'สาขา',
        division:'ฝ่าย',
        department:'แผนก',
        description: 'รายละเอียด',
    },
    table: {
        action: 'การกระทำ',
        noDataFound: 'ไม่พบข้อมูล',
    },
    login: {
        username: 'Username',
        password: 'Password'
    },
    msg: {
        please: {
            type: 'โปรดระบุ',
            fill: 'โปรดระบุ',
            select: 'โปรดเลือก'
        },
        confirm: {
            submit: 'คุณต้องการยืนยันข้อมูลใช่หรือไม่?',
            save: 'คุณต้องการบันทึกข้อมูลใช่หรือไม่?',
            delete: 'คุณต้องการลบข้อมูลใช่หรือไม่?'
        },
        alert: {
            saveSuccessful: 'บันทึกข้อมูลเรียบร้อยแล้ว',
            deleteSuccessful: 'ลบข้อมูลเรียบร้อยแล้ว',
        },
        validate: {
            year: 'ต้องเป็นปีพุทธศักราช และต้องไม่น้อยกว่าหรือเท่ากับปีปัจจุบัน - 100 ปี',
            formatDate: 'กรุณาตรวจสอบรูปแแบบ วัน/เดือน/ปี ให้ถูกต้อง',
            formatTime: 'รูปแแบบไม่ถูกต้อง ชั่วโมง 00-23 นาที 00-59',
            idCard: 'หมายเลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
            uploadFile: 'กรุณาอัพโหลดเอกสารแนบ'
        }
    },
    placeholder: {
        username: 'Username',
        password: 'Password',
        pleaseFill: 'โปรดระบุ',
        pleaseSelect: 'โปรดเลือก',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
        timeFormat: 'HH:mm',
        AnnoDomini: 'ปีคริสต์ศักราช',
        BuddhistEra: 'ปีพุทธศักราช'
    },
    menu:{
        mainMenu: 'หน้าหลัก',
        employeeProfile: 'ข้อมูลพนักงาน',
        report: {
            title: 'รายงาน',
            employeeProfile: 'รายงานพนักงาน'
        },
        systemSetup:{
            title:'ตั้งค่าระบบ',
            userSetup:'ตั้งค่าผู้ใช้',
            roleSetup:'ตั้งค่า Role',
            jobSchedulerSetup: 'ตั้งค่า Job Scheduler',
            jobLogSetup: 'Job Log'
        },
    },
    btn:{
        search: 'ค้นหา',
        clear: 'ล้างข้อมูล',
        close: 'ปิด',
        save: 'บันทึก',
        back: 'ย้อนกลับ',
        create: 'สร้าง',
        edit: 'แก้ไข',
        delete: 'ลบ',
        start:'เริ่มเรียน',
        next:'ต่อไป',
        previous:'ย้อนกลับ',
        cancel:'ยกเลิก',
        submit:'ยืนยัน',
        print:'พิมพ์',
        closeWindow:'ปิดหน้าต่าง',
        detail:'รายละเอียด',
        nextPage:'หน้าถัดไป',
        previousPage:'หน้าก่อนหน้า',
        view:'ดู',
        add:'เพิ่ม',
        upload:'อัปโหลด',
        download: 'ดาวน์โหลด',
        export: 'Export',
        chooseFile: 'Choose File',
        uploadFile: 'Upload File',
        abort: 'abort',
    },
    upload: {
        modalTitle: 'สถานะการอัปโหลดไฟล์: ',
        chooseFile : 'เลือกไฟล์',
        uploadFile: 'อัปโหลดไฟล์',
        abort: 'ยกเลิกอัปโหลด',
        success: 'สำเร็จ',
        fail: 'ไม่สำเร็จ',
        failMsg: 'กรุณาแก้ไขและอัปโหลดไฟล์ที่ถูกต้อง',
    },
    // ############################## SYSTEM SETUP ##############################
    usersetup: {
        search: 'ค้นหาผู้ใช้งาน',
        userInfo: 'ข้อมูลพนักงาน',
        userCode: 'รหัสพนักงาน',
        userName: 'ชื่อพนักงาน',
        firstName: 'ชื่อ',
        lastName: 'นามสกุล',
        status: 'สถานะ',
        role: 'Role',
        email: 'Email',
        roleName: 'Role Name',
        createdBy: 'ผู้สร้าง',
        createdDate: 'วันที่สร้าง',
        updatedBy: 'ผู้แก้ไข',
        updatedDate: 'วันที่แก้ไข'
    },
    rolesetup: {
        search: 'ค้นหา Role',
        roleInfo: 'ข้อมูล Role',
        roleCode: 'Role Code',
        roleName: 'Role Name',
        roleDesc: 'Role Description',
        status: 'สถานะ',
        createdBy: 'ผู้สร้าง',
        createdDate: 'วันที่สร้าง',
        updatedBy: 'ผู้แก้ไข',
        updatedDate: 'วันที่แก้ไข'
    },
    jobsetup: {
        search: 'ค้นหา Job Schedule',
        jobInfo: 'Job Schedule Info',
        jobName: 'Job Name',
        jobType: 'Job Type',
        scheduleType: 'Schedule Type',
        cronExpression: 'Cron Expression',
        dayOfWeek: 'Day of Week',
        dayOfMonth: 'Day of Month',
        jobStatus: 'Job Status',
        nextRun: 'Next Run',
        description: 'Description',
        startTime: 'Start Time',
        startDate: 'Start Date',
        endDate: 'End Date',
        status: 'สถานะ',
        createdBy: 'ผู้สร้าง',
        createdDate: 'วันที่สร้าง',
        updatedBy: 'ผู้แก้ไข',
        updatedDate: 'วันที่แก้ไข'
    },
    joblog: {
        search: 'ค้นหา Job Log',
        jobName: 'Job Name',
        jobType: 'Job Type',
        scheduleType: 'Schedule Type',
        jobStatus: 'Job Status',
        startDate: 'Start Date',
        endDate: 'End Date',
        message: 'Message',
        status: 'สถานะ'
    },
    // ############################## EMPLOYEE PROFILE ##############################
    employee: {
        employeeCode: 'รหัสพนักงาน',
        employeeName: 'ชื่อพนักงาน',
        titleTh: 'คำนำหน้าชื่อ (TH)',
        titleEn: 'คำนำหน้าชื่อ (EN)',
        nickNameTh: 'ชื่อเล่น',
        nameTh: 'ชื่อพนักงาน (TH)',
        nameEn: 'ชื่อพนักงาน (EN)',
        lastNameTh: 'นามสกุล (TH)',
        lastNameEn: 'นามสกุล (EN)',
        birthDate: 'วัน/เดือน/ปีเกิด',
    //  ### Tab Employee Info
        employeeInfo: 'ข้อมูลพนักงาน',
        marital: 'สถานะสมรส',
        race: 'เชื้อชาติ',
        nationallity: 'สัญชาติ',
        religion: 'ศาสนา',
        blood: 'กรุ๊ปเลือด',
        military: 'สถานะทางทหาร',
        dayOfBirth: 'วันเกิด',
        placeOfฺBirth: 'จังหวัดที่เกิด',
        timeOfBirth: 'เวลาที่เกิด',
        dateOfBirth: 'วันที่เกิด',
        unknown: 'ไม่ทราบ',
    //  ### Tab Address  
        addressInfo: 'ที่อยู่',
        addressSystem: 'ที่อยู่จากในระบบ',
        useSamePermanentAddress: 'ใช้ที่อยู่เดียวกับทะเบียนบ้าน',
        address: 'บ้านเลขที่',
        moo: 'หมู่',
        build: 'หมู่บ้าน/อาคาร',
        soi: 'ซอย',
        road: 'ถนน',
        province: 'จังหวัด',
        district: 'อำเภอ/เขต',
        subDistrict: 'ตำบล/แขวง',
        zipCode: 'รหัสไปรษณีย์',
        telephone: 'เบอร์โทรศัพท์',
        mobile1: 'เบอร์โทรศัพท์ที่ติดต่อได้',
        mobile2: 'เบอร์โทรศัพท์ที่ติดต่อได้',
    //  ### Tab Education
        educationInfo: 'ประวัติการศึกษา',
        educationLevel: 'ระดับการศึกษา',
        degree: 'ชื่อวุฒิการศึกษา',
        major: 'คณะ/สาขาวิชา',
        minor: 'สาขาวิชาเอก',
        institution: 'สถาบัน',
        country: 'ประเทศที่จบการศึกษา',
        gpa: 'เกรดเฉลี่ย',
        studyFrom: 'ปีที่เริ่มการศึกษา',
        studyTo: 'ปีที่จบการศึกษา',
        attachfile: 'เอกสารแนบ',
    //  ### Tab Family
        familyInfo: 'ข้อมูลครอบครัว',
        familyTitle: 'ข้อมูลบิดา-มารดา',
        fatherName: 'ชื่อ-นามสกุลบิดา',
        fatherIdCard: 'เลขที่บัตรประจำตัวประชาชนบิดา',
        fatherOccupation: 'อาชีพของบิดา',
        motherName: 'ชื่อ-นามสกุลมารดา',
        motherIdCard: 'เลขที่บัตรประจำตัวประชาชนมารดา',
        motherOccupation: 'อาชีพของมารดา',
        urgentName: 'ชื่อ-นามสกุลผู้ติดต่อฉุกเฉิน',
        urgentRelation: 'ความเกี่ยวข้อง',
        urgentPhone: 'เบอร์โทรศัพท์ผู้ติดต่อฉุกเฉิน',
        spouseTitle: 'ข้อมูลคู่สมรส',
        spouseName: 'ชื่อ-นามสกุลคู่สมรส',
        marriedDate: 'วันที่จดทะเบียนสมรส',
        spouseIdCard: 'เลขที่บัตรประชาชนคู่สมรส',
        spouseAttachfile: 'แนบเอกสารใบจดทะเบียนสมรส',
        childrenTitle: 'ข้อมูลบุตร',
        childrenName: 'ชื่อ-นามสกุลบุตร',
    //  ### Tab Work Experience
        workExperienceInfo: 'ประวัติการทำงาน',
        companyName: 'ชื่อบริษัท',
        positionName: 'ตำแหน่ง',
        startDate: 'วันที่เริ่มงาน',
        endDate: 'วันที่ลาออกจากงาน',
    //  ### Tab Certificate
        certificateInfo: 'ใบประกอบวิชาชีพ',
        certGroupName: 'ประเภทหลักสูตร/ใบอนุญาต',
        certName: 'หลักสูตร/ใบอนุญาต',
        certNo: 'เลขทะเบียน',
        certYear: 'ปีที่ได้รับ',
        certBy: 'หน่วยงานที่ออกให้',
    },
    // ############################## REPORT ##############################
    report: {
        employeeCode: 'รหัสพนักงาน',
        employeeName: 'ชื่อพนักงาน',
        period: 'Period',
        format: 'Format',
        store: 'สาขา',
        division: 'ฝ่าย',
        department: 'แผนก',
        empStatus: 'สถานะ',
        search: 'ค้นหา',
    }
};
